import MomentUtils from '@date-io/moment';
import { createMuiTheme, darken, lighten, ThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import L from 'leaflet';
import React from 'react';
import { Provider } from 'react-redux';

import AuthStatePersistor from './components/authStatePersistor/authStatePersistor';
import { COLORS_PROJECT } from './constants';
import { AppRouter } from './routes/AppRouter';
import { store } from './store/store';

const { color_nav, color_nav_letter, color_nav_secondary, color_nav_letter_secondary, color_back } = COLORS_PROJECT;
const theme = createMuiTheme({
    palette: {
        primary: {
            light: lighten(color_nav, 0.2),
            main: color_nav,
            dark: darken(color_nav, 0.2),
            contrastText: color_nav_letter,
        },
        secondary: {
            light: lighten(color_nav_secondary, 0.2),
            main: color_nav_secondary,
            dark: darken(color_nav_secondary, 0.2),
            contrastText: color_nav_letter_secondary,
        },
        background: {
            default: color_back,
        },
    },
});

L.MarkerCluster = L.MarkerCluster.extend({
    options: { pmIgnore: true, ...L.Icon.prototype.options },
});

export const Scada = () => {
    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <MuiPickersUtilsProvider locale="es" utils={MomentUtils}>
                    <AppRouter />
                    <AuthStatePersistor />
                </MuiPickersUtilsProvider>
            </ThemeProvider>
        </Provider>
    );
};
